import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const LOAD_CUSTOMER = 'LOAD_CUSTOMER';
export const LOAD_CUSTOMER_DATA = 'LOAD_CUSTOMER_DATA';
export const LOAD_CUSTOMER_DATA_FAILURE = 'LOAD_CUSTOMER_DATA_FAILURE';
export const LINK_CUSTOMER_ACCOUNT = 'LINK_CUSTOMER_ACCOUNT';
export const UNLINK_CUSTOMER_ACCOUNT = 'UNLINK_CUSTOMER_ACCOUNT';
export const CLEAR_CHANGECUSTOMERID_REQUEST = 'CLEAR_CHANGECUSTOMERID_REQUEST';
export const CLEAR_CUSTOMER_REQUEST = 'CLEAR_CUSTOMER_REQUEST';

function requestLoadCustomer(customer) {
  return {
    type: LOAD_CUSTOMER,
    storeCustomer: customer
  };
}

function requestLoadCustomerData() {
  return {
    type: LOAD_CUSTOMER_DATA,
  };
}

function requestLinkCustomerAccount() {
  return {
    type: LINK_CUSTOMER_ACCOUNT,
  };
}

function requestUnlinkCustomerAccount() {
  return {
    type: UNLINK_CUSTOMER_ACCOUNT,
  };
}

export function clearCompletedCustomerIdChange() {
  return {
    type: CLEAR_CHANGECUSTOMERID_REQUEST
  };
}

export function clearCustomer() {
  return {
    type: CLEAR_CUSTOMER_REQUEST
  };
}

function rejectCustomerDataLoad(customerDataLoadError) {
  return {
    type: LOAD_CUSTOMER_DATA_FAILURE,
    customerDataLoadError
  };
}

export function customerDataLoad(customerId) {
  return (dispatch) => {
    dispatch(requestLoadCustomerData());

    const promise = () => ApiService
      .getCustomerData(customerId)
      .then((response) => {
        dispatch(requestLoadCustomer(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectCustomerDataLoad));
        }
      });
    return promise();
  };
}

export function clearCustomerData() {
  return dispatch => dispatch(clearCustomer());
}

export function customerAccountLink(customerId, addedAccountData) {
  return (dispatch) => {
    dispatch(requestLinkCustomerAccount());

    const customerAccount = {
      CustomerId: customerId,
      Capacity: addedAccountData.capacity,
      ValidFrom: addedAccountData.validFrom,
      ValidUntil: addedAccountData.validUntil,
      Account: {
        id: addedAccountData.accountNumber ? addedAccountData.accountNumber.id : 0,
        accountNumber: addedAccountData.accountNumber ? addedAccountData.accountNumber.value : ''
      }
    };

    const customerAccounts = [customerAccount];
    const promise = () => ApiService
      .linkCustomerAccount(customerId, customerAccounts)
      .then((response) => {
        dispatch(customerDataLoad(customerId));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, true, true));
        }
      });
    return promise();
  };
}

export function customerAccountUnlink(customerId, accountId) {
  const customerAccounts = [accountId];

  return (dispatch) => {
    dispatch(requestUnlinkCustomerAccount());

    const promise = () => ApiService
      .unLinkCustomerAccount(customerId, customerAccounts)
      .then((response) => {
        dispatch(customerDataLoad(customerId));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, true, true));
        }
      });
    return promise();
  };
}
